import { ApiClient } from '@/shared/api-client';
import { ISpeakerRequest } from '@/shared/api-client/models/speaker/speaker-request';
import { Component, Prop, Vue } from 'vue-property-decorator';
import SpeakerQueueListComponent from '../speaker-queue-list-component/speaker-queue-list-component.vue';

@Component({
    components: {
        SpeakerQueueListComponent
    }
})
export default class SpeakerQueueDialogComponent extends Vue {

    @Prop() public activityId!: string;
    @Prop({ default: undefined }) public currentUserId!: string;
    @Prop({ default: () => ({}) }) public translations!: { [key: string]: string };

    public isLoading = false;
    public speakersQueue: ISpeakerRequest[] = [];

    private apiClient: ApiClient = new ApiClient();
    private agendaItemId: string | undefined = undefined;

    public get modalName(): string {
        return `SpeakerQueueModal-${this.agendaItemId}`;
    }

    public mounted(): void {
        // Move only the modal element (not the button) to <body> so it is not trapped
        // inside a parent modal's stacking context.
        const modalEl = (this.$refs.queueModal as Vue).$el;
        document.body.appendChild(modalEl);
    }

    public beforeDestroy(): void {
        const modalEl = (this.$refs.queueModal as Vue).$el;
        if (modalEl.parentNode === document.body) {
            document.body.removeChild(modalEl);
        }
    }

    public async open(agendaItemId: string): Promise<void> {

        this.agendaItemId = agendaItemId;

        await this.refresh();

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (window as any).$(this.getModalSelector()).modal('show');
    }

    public onCancelled(): void {
        this.refresh();
    }

    private getModalSelector(): string {
        return `#${this.modalName}`;
    }

    public async refresh(): Promise<void> {
        this.isLoading = true;


        try {

            if (this.agendaItemId) {

                const queues = await this.apiClient.speakerRequest.getQueue(this.activityId, this.agendaItemId);
                this.speakersQueue = queues.queue || [];
            }

        } finally {
            this.isLoading = false;
        }
    }
}
